// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".used[data-v-6b02f9f9]{color:#008ca0;font-weight:700}.unused[data-v-6b02f9f9]{color:#707070}.delete-btn[data-v-6b02f9f9],.edit-btn[data-v-6b02f9f9]{width:64px}.testmail-btn[data-v-6b02f9f9]{width:100px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
